import { jsx as _jsx } from "react/jsx-runtime";
import { useAsset } from '@dfx.swiss/react';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useStore } from '../hooks/store.hook';
import { isDefined } from '../util/utils';
const BalanceContext = createContext(undefined);
export function useBalanceContext() {
    return useContext(BalanceContext);
}
export function BalanceContextProvider(props) {
    const { balances: storeBalances } = useStore();
    const [balances, setBalances] = useState();
    const { getAsset } = useAsset();
    useEffect(() => {
        if (!balances)
            readBalances(storeBalances.get());
    }, []);
    function readBalances(param) {
        param ? storeBalances.set(param) : storeBalances.remove();
        setBalances(param === null || param === void 0 ? void 0 : param.split(',').map((balance) => {
            const split = balance.split('@');
            if (split.length !== 2)
                return undefined;
            return { asset: split[1], amount: +split[0] };
        }).filter(isDefined));
    }
    function getBalances(assets) {
        if (!balances)
            return undefined;
        return assets
            .map((asset) => {
            var _a;
            const amount = (_a = balances.find((b) => { var _a; return ((_a = getAsset(assets, b.asset)) === null || _a === void 0 ? void 0 : _a.id) === asset.id; })) === null || _a === void 0 ? void 0 : _a.amount;
            return amount ? { asset, amount } : undefined;
        })
            .filter(isDefined);
    }
    const context = useMemo(() => {
        var _a;
        return ({
            getBalances,
            readBalances,
            hasBalance: (_a = balances === null || balances === void 0 ? void 0 : balances.some((balance) => balance.amount > 0)) !== null && _a !== void 0 ? _a : false,
        });
    }, [balances]);
    return _jsx(BalanceContext.Provider, Object.assign({ value: context }, { children: props.children }));
}
